import { Component } from '@angular/core';

@Component({
  selector: 'app-checkout-review',
  standalone: false,
  templateUrl: './checkout-review.component.html',
  styleUrls: ['./checkout-review.component.scss']
})
export class CheckoutReviewComponent {

}
